import { ROADMAP, SATELLITE, TERRAIN } from '../../constants';
const buildMapTypeIds = (enableSatelliteView, enableTerrainScreen) => {
  const mapTypeIds = [ROADMAP];
  if (enableSatelliteView) mapTypeIds.push(SATELLITE);
  if (enableTerrainScreen) mapTypeIds.push(TERRAIN);
  return mapTypeIds;
};
export default buildMapTypeIds;
//# sourceMappingURL=build-map-type-ids.js.map